/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/dnd-core/~/lodash/_freeGlobal.js
 ** module id = 864
 ** module chunks = 0
 **/